import { useEffect, useState, useTransition } from 'react';
import { useNavigate } from 'react-router-dom';

import { manualFinish } from '~modules/journal/api';
import { getFileFromBase64 } from '~shared/helpers';
import { routerKeys } from '~shared/router';
import { toastError, toastSuccess } from '~shared/ui';

export function useEndSession(userId: string) {
	const [photo, setPhoto] = useState<string | null>(null);
	const [pending, startEnd] = useTransition();
	const navigate = useNavigate();

	useEffect(() => {
		setPhoto(null);
	}, [userId]);

	function clear() {
		setPhoto(null);
	}

	function end() {
		startEnd(async () => {
			try {
				const file = getFileFromBase64(photo!, 'photo.jpg');
				await manualFinish(parseInt(userId), file);
				toastSuccess('Данные успешно сохранены');
				navigate(routerKeys.manager.root());
			} catch (err) {
				console.error(err);
				toastError('Ошибка сохранения данных');
			}
		});
	}

	return { pending, photo, setPhoto, clear, end };
}
